import { ChangeDetectorRef, Directive } from '@angular/core';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { BoardSourceType } from '@main-application/boards/interfaces/board.enums';

@Directive()
export abstract class KanbanAbstract extends ComponentAbstract {
  isLoading = false;
  inspectTurnoverId: number = null;
  BoardSourceType = BoardSourceType;

  protected constructor(protected cdr: ChangeDetectorRef) {
    super(cdr);
  }

  toggleLoading(isLoading: boolean) {
    this.isLoading = isLoading;
    this.cdr.detectChanges();
  }
}
